export default "__VITE_ASSET__Cv0jb4NG__"